import {
  SSP_AD_MODES,
  SSP_PARTNER_AD_MODES,
  WEB_AUTO_LOGIN,
  YANDEX_AD_MODES,
} from '@web-catalog/types/omicron';

import {
  ConfigSchema,
  getBoolean,
  getString,
  getStringMap,
  getStringUnion,
  InferConfigType,
  OmicronConfigResponseType,
  WithTypeCheck,
} from '@utils/omicron';

import {
  AdFoxConfigValidator,
  NewMainPageBlocksOrderConfigValidator,
  RoundingRulesValidator,
} from './customValidators';

export const OmicronConfigSchema = {
  IS_SHOW_APP_CARD_RATING: {
    value: getBoolean(),
    description: 'Флаг включает отображение рейтинга приложения в списке',
    team: 'Growth',
  },
  WEB_TECHNICAL_WORKS: {
    value: getBoolean(),
    description: 'Флаг включает режим технических работ для витрины',
    team: 'Growth',
  },
  WEB_AUTO_DOWNLOAD: {
    value: getBoolean(),
    description:
      'Флаг включает автоматическую загрузку при нажатии на кнопку установки',
    team: 'Growth',
  },
  RULES_FOR_DOWNLOADS_COUNT_GAMES: {
    value: RoundingRulesValidator,
    description: 'Правило округления количества скачиваний игр для игр',
    team: 'Growth',
  },
  RULES_FOR_DOWNLOADS_COUNT_APPS: {
    value: RoundingRulesValidator,
    description:
      'Правило округления количества скачиваний приложений для приложений',
    team: 'Growth',
  },
  WEB_SIMILAR_APPS_DISCLAIMER: {
    value: getBoolean(),
    description:
      'Флаг включает дисклеймер об использовании рекомендательных систем',
    team: 'Growth',
  },
  WEB_SEARCH_EXPS: {
    value: getString(),
    description:
      'Параметр для проведения A/B тестирования поиска. Значение тогла передается в headers в запросах к backend',
    team: 'Growth',
  },
  WEB_YANDEX_AD_MODE: {
    value: getStringUnion('none', YANDEX_AD_MODES),
    description: 'Режимы рекламы Яндекса в витрине',
    team: 'Growth',
  },
  WEB_AUTO_LOGIN: {
    value: getStringUnion('none', WEB_AUTO_LOGIN),
    description:
      'Флаг на доступность и тип отображения автологина на веб витрине',
    team: 'Growth',
  },
  WEB_ENABLE_SELECTIONS_STRAPI: {
    value: getBoolean(),
    description:
      'Флаг на включение подмешивания приложений из страпи в подборку "Возможно вам понравится" на странице приложения',
    team: 'Growth',
  },
  WEB_SSP_AD_MODE: {
    value: getStringUnion('none', SSP_AD_MODES),
    description: 'Флаг на отображение типа рекламы SSP',
    team: 'Ads',
  },
  WEB_SSP_AD_PARTNER: {
    value: getStringUnion('none', SSP_PARTNER_AD_MODES),
    description: 'Флаг типа партнеров рекламы SSP',
    team: 'Ads',
  },
  WEB_SSP_AD_WITH_AUTH: {
    value: getBoolean(),
    description: `Отправка запроса(и показ баннера в случае успеха) на ssp рекламу
      в витрине только с авторизированными юзерами с vk id`,
    team: 'Ads',
  },
  WEB_SSP_SCRIPT_ENABLED: {
    value: getBoolean(),
    description:
      'Флаг на переключение реализации ssp рекламы с next на внешний скрипт',
    team: 'Ads',
  },
  WEB_YANDEX_AD_LEFT_SIDEBAR_ENABLED: {
    value: getBoolean(),
    description:
      'Флаг на показ рекламы РСЯ на большом десктопе главной страницы под списком категорий',
    team: 'Growth',
  },
  WEB_YANDEX_AD_RIGHT_SIDEBAR_ENABLED: {
    value: getBoolean(),
    description:
      'Флаг на показ рекламы РСЯ справа на большом десктопе страницы приложения',
    team: 'Growth',
  },
  WEB_YANDEX_AD_APPS_LIST_ENABLED: {
    value: getBoolean(),
    description:
      'Флаг на подмешивание рекламы в списках приложений в категориях',
    team: 'Growth',
  },
  WEB_GAME_MARKINGS_ENABLED: {
    value: getBoolean(),
    description:
      'Флаг отображения возрастной маркировки для игр в карточке приложения + страницы с возрастной маркировкой',
    team: 'Phoenix',
  },
  WEB_ENABLE_HIDDEN_EXCEPTIONS: {
    value: getBoolean(),
    description:
      'Флаг на включение и выключение исключений для скрытых приложений в Strapi',
    team: 'Growth',
  },
  WEB_SEARCH_TAGS_ENABLED: {
    value: getBoolean(),
    description: 'Флаг на отображение тегов приложений',
    team: 'Growth',
  },
  WEB_ENABLE_LABELS_AND_SEO_TAGS: {
    value: getBoolean(),
    description: 'Флаг на отображение отметок редакции и сео-тегов приложений',
    team: 'Growth',
  },
  WEB_ENABLE_NEW_DEEPLINK: {
    value: getBoolean(),
    description:
      'Флаг на включение нового диплинка на инструкцию с плашкой с кнопки "Установить с помощью RuStore"',
    team: 'Growth',
  },
  WEB_ENABLE_NEW_SCHEME_DEEPLINK: {
    value: getBoolean(),
    description:
      'Флаг на включение новой схемы диплинка на карточку приложения для ссылки "Установить с помощью RuStore"',
    team: 'Larek',
  },
  WEB_ENABLE_REDIRECT_FROM_APPCARD: {
    value: getBoolean(),
    description:
      'Флаг включает в мобильной версии витрины редирект на apk приложение при переходе в карточку приложения',
    team: 'Larek',
  },
  WEB_ENABLE_SELECTIONS_ON_MAIN: {
    value: getBoolean(),
    description: 'Флаг на включение новой главной с подборками',
    team: 'Growth',
  },
  WEB_SELECTIONS_ON_MAIN_BLOCK_ORDER: {
    value: NewMainPageBlocksOrderConfigValidator,
    description: 'Конфиг на порядок блоков на новой главной',
    team: 'Growth',
  },
  WEB_SHOW_VIDEO_IN_APP_SCREENSHOTS: {
    value: getBoolean(),
    description: 'Флаг на добавление видео в карусель скриншотов',
    team: 'Growth',
  },
  WEB_ENABLE_PREORDER_REDESIGN: {
    value: getBoolean(),
    description: 'Флаг редизайна подборок с предзаказами',
    team: 'Growth',
  },
  WEB_YANDEX_PLACEMENTS_APPS: {
    value: getStringMap(),
    description: 'JSON для мапинга отображения рекламы на главной приложений',
    team: 'Growth',
  },
  WEB_YANDEX_PLACEMENTS_GAMES: {
    value: getStringMap(),
    description: 'JSON для мапинга отображения рекламы на главной игр',
    team: 'Growth',
  },
  ENABLE_RATING: {
    value: getBoolean(),
    description:
      'Включение отображение рейтинга на главной, по совместительству редизайн его же',
    team: 'Growth',
  },
  ENABLE_LAZY_SCRIPTS: {
    value: getBoolean(),
    description: 'Флаг для быстрого отключения ленивых скриптов',
    team: 'Growth',
  },
  ADFOX_CONFIG: {
    value: AdFoxConfigValidator,
    description:
      'Тоггл отвечает за переключение между прямой интеграцией с РСЯ и AdFox',
    team: 'Growth',
  },
  ENABLE_URLS: {
    value: getBoolean(),
    description:
      'RM-3634 включает парсинг урлов в описаниях, отзывах и что нового у приложений',
    team: 'Growth',
  },
  ENABLE_KIOSK_PAGE: {
    value: getBoolean(),
    description: 'Тоггл отвечает за показ страницы с киоском',
    team: 'Growth',
  },
  ENABLE_TV_APP_PAGE: {
    value: getBoolean(),
    description: 'Флаг на показ страницы с приложениями для ТВ',
    team: 'Growth',
  },
} satisfies ConfigSchema;

export type OmicronContent = InferConfigType<
  WithTypeCheck<typeof OmicronConfigSchema>
>;

export type OmicronFlags = keyof typeof OmicronConfigSchema;

export type OmicronDTO = OmicronConfigResponseType<OmicronContent> & {
  /**
   * если не получили конфиг через заголовки на сервер-сайде и сходили в омикрон сами,
   * то оид надо будет записать в куку с клиента
   */
  writeOidCookie?: boolean;
};
